// @flow
import React, { useState, useRef } from 'react';
import ReactPlayer from 'react-player';
import playButton from 'assets/images/Play-Button-S.png';
import pauseButton from 'assets/images/pause.png';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import './styles.scss';

type Props = {};

export const VideoOverlay = (props: Props) => {
  const { data, onClosePress } = props;
  const [isVideoPlaying, setVideoPlaying] = useState(false);
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);
  const [videoPlayedPercentage, setVideoPlayedPercentage] = useState(0);
  const [remainingSeconds, setRemainingSeconds] = useState(0);
  const [duration, setDuration] = useState(0);
  const [isSeeking, setIsSeeking] = useState(false);
  const player = useRef(ReactPlayer);

  const CurrentVideoStatus = data => {
    if (!isSeeking) {
      const remainingTime = !data
        ? 0
        : parseFloat((duration - data.playedSeconds) / 60).toFixed(2);
      setVideoPlayedPercentage(data.played);
      setRemainingSeconds(remainingTime);
    }
  };

  const handleSeekMouseDown = e => {
    setIsSeeking(true);
  };

  const handleSeekChange = e => {
    setVideoPlayedPercentage(parseFloat(e.target.value));
  };

  const handleSeekMouseUp = e => {
    player.current.seekTo(parseFloat(e.target.value));
    setIsSeeking(false);
  };

  const handleOnready = e => {
    setIsVideoLoaded(true);
  };

  return (
    <div className={'video-overlay'}>
      <div className={'video-container'}>
        {data && (
          <>
            <div className="player-wrapper-overlay">
              <ReactPlayer
                ref={player}
                className="react-player"
                url={data}
                width="100%"
                height="100%"
                playing={isVideoPlaying}
                onProgress={CurrentVideoStatus}
                onReady={e => handleOnready(e)}
                loop={false}
                onEnded={() => onClosePress()}
                onDuration={e => setDuration(e)}
                config={{
                  vimeo: {
                    playerOptions: { playsinline: true },
                  },
                }}
              />
            </div>
            {isVideoLoaded && (
              <Row className="player-controls">
                <Col className="play-control" xs={{ span: 2 }} sm={{ span: 2 }}>
                  {isVideoPlaying && (
                    <img
                      className={'play-icon'}
                      src={pauseButton}
                      alt={'icon'}
                      style={{ width: '35px', height: '35px' }}
                      onClick={() => setVideoPlaying(!isVideoPlaying)}
                    />
                  )}
                  {!isVideoPlaying && (
                    <img
                      className={'play-icon'}
                      src={playButton}
                      alt={'icon'}
                      style={{ width: '35px', height: '35px' }}
                      onClick={() => setVideoPlaying(!isVideoPlaying)}
                    />
                  )}
                </Col>
                <Col
                  className="seek-control-overlay"
                  xs={{ span: 8 }}
                  sm={{ span: 8 }}
                >
                  <input
                    type="range"
                    min={0}
                    max={0.999999}
                    step="any"
                    value={videoPlayedPercentage}
                    onMouseDown={handleSeekMouseDown}
                    onChange={handleSeekChange}
                    onMouseUp={handleSeekMouseUp}
                  />
                </Col>
                <Col
                  className="time-control-video-overlay"
                  xs={{ span: 2 }}
                  sm={{ span: 2 }}
                >
                  <p>-{remainingSeconds}</p>
                </Col>
              </Row>
            )}
          </>
        )}
      </div>
    </div>
  );
};
